let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eB4bT")).then(() => parcelRequire('fhOSk'));